/**
 * A box that opens with a blank text field puts the cursor in it (Tim, 2026-10-01).
 *
 * One rule for every dialog, popover, and inline form: EsDialog and EsPopover apply it
 * themselves, and an inline form passes `esFocusBlankOnMount` as its `ref`. A field that
 * opens with a value in it is left alone -- a rename wants its text selected by the
 * person, not stolen -- and so is a box with no text field at all.
 *
 * Deferred one tick because the dialog's focus trap puts focus on its first focusable
 * part (the close X) as it mounts; the trap leaves focus alone once it is inside the
 * popup, so whichever lands second, the field keeps it.
 */
const TEXT_FIELDS = [
    'input:not([type])', 'input[type="text"]', 'input[type="search"]', 'input[type="email"]',
    'input[type="password"]', 'input[type="url"]', 'input[type="tel"]', 'input[type="number"]',
    'textarea', '[contenteditable="true"]',
].join( ',' );

const isBlank = ( pField ) => pField.isContentEditable
    ? !pField.textContent.trim()
    : !pField.value;

/** Focuses the first blank, usable text field under `pRoot`; false when there is none. */
export function esFocusFirstBlank( pRoot ) {
    const aField = Array.from( pRoot?.querySelectorAll( TEXT_FIELDS ) ?? [] )
        .find( ( pOne ) => !pOne.disabled && !pOne.readOnly && isBlank( pOne ) );
    if ( !aField ) return false;

    aField.focus( { preventScroll: true } );
    return true;
}

// Module scope so React calls it on mount and unmount only, never on a re-render.
export function esFocusBlankOnMount( pElement ) {
    if ( !pElement ) return undefined;

    const aTimer = setTimeout( () => esFocusFirstBlank( pElement ), 0 );
    return () => clearTimeout( aTimer );
}
